<template>
    <v-card>
        <v-card-text>
            <v-stepper v-model="step" style="height: 100%; box-shadow: none;">
                <v-stepper-items>
                    <v-stepper-content step="1" class="pa-0">
                        <v-layout justify-center>
                            <v-icon color="success" size="150">local_atm</v-icon>
                        </v-layout>
                        <h1 class="text-xs-center success--text" style="font-weight: 900;">
                            Programa de Assinatura
                        </h1>
                        <p style="font-size: 1.3em; text-align: justify;" class="mt-4">
                            Através do <b>Programa de Assinatura</b> você pode cobrar dos seus clientes uma mensalidade e oferecê-los descontos exclusivos.
                        </p>
                        <v-layout justify-center>
                            <v-btn round color="success" @click="step = 3">Participar</v-btn>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="pa-0">
                        <h2 class="mb-3 text-xs-center grey--text">Visualize seus planos de assinatura</h2>
                        <v-list>
                          <v-list-tile v-for="(plano, index) in planos" :key="index" ripple style="height: 4em;">
                              <v-list-tile-content style="width: 20%;" class="pa-0">
                                  <h2 v-if="!plano.externo" style="width: 100%; font-size: 0.9em;">{{plano.valor | currency({fractionCount: 2})}}</h2>
                              </v-list-tile-content>
                              <v-list-tile-content style="width: 60%;">
                                  <v-list-tile-title class="text-xs-center">{{ plano.descricao }}</v-list-tile-title>
                                  <v-list-tile-sub-title class="text-xs-center" v-if="!plano.externo">
                                    Plano: {{ plano.intervalo == 1 ? 'Mensal' : 'Anual' }}
                                    /
                                    Renovação: {{ plano.gateway ? 'Automática' : 'Manual' }}
                                  </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action style="width: 20%;">
                                <v-layout wrap>
                                  <v-tooltip bottom>
                                    <v-btn slot="activator" icon @click="planoSelecionado = plano, step = 5">
                                      <v-icon color="error">close</v-icon>
                                    </v-btn>
                                    <span>Cancelar Plano</span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                                    <v-btn
                                      slot="activator"
                                      icon
                                      @click="editar(plano)"
                                    >
                                      <v-icon color="primary">edit</v-icon>
                                    </v-btn>
                                    <span>Editar plano</span>
                                  </v-tooltip>
                                  <v-tooltip bottom class="ml-2">
                                    <v-btn slot="activator" icon @click="planoSelecionado = plano, step = 4">
                                      <v-icon color="info">remove_red_eye</v-icon>
                                    </v-btn>
                                    <span>Visualizar Plano</span>
                                  </v-tooltip>
                                </v-layout>
                              </v-list-tile-action>
                          </v-list-tile>
                          <v-list-tile v-if="planos.length === 0">
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">Sem planos no momento</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                      <v-layout column>
                         <v-btn block round @click="novoPlano" color="success"><v-icon class="mr-2">add</v-icon> Adicionar Novo Plano</v-btn>
                        <v-btn class="mb-2" block round @click="$emit('fechar')">Fechar</v-btn>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <h2 class="mb-3 text-xs-center green--text">Para confirmar seu cadastro preencha os seguintes campos</h2>
                        <v-flex xs12>
                          <label class="body-1 font-weight-medium">
                            Usar sistema externo para gerenciar assinatura?
                          </label>
                        </v-flex>

                        <v-flex xs12>
                          <v-radio-group v-model="plano_externo" row>
                            <v-radio
                              label="SIM"
                              :value="true"
                              class="mr-4"
                            ></v-radio>
                            <v-radio
                              label="NÃO"
                              :value="false"
                              class="mr-4"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <v-text-field
                            v-if="step === 3"
                            label="Valor do plano"
                            :disabled="(planoSelecionado && !!planoSelecionado.gateway) || plano_externo"
                            outline
                            v-money="money"
                            v-model.lazy="valor"
                            prefix="R$"
                            :rules="[
                              v => !!v || 'Valor Inválido',
                              v => v.replaceAll('.', '').replace(',', '.') >= 5 || 'Valor precisa ser maior que R$ 4,99'
                            ]"
                        ></v-text-field>
                        <v-select
                            outline
                            :items="appList"
                            label="Selecione o Aplicativo"
                            v-model="app_selecionado"
                            hide-details
                            :disabled="!!planoSelecionado"
                            item-text="text"
                            item-value="value"
                        ></v-select>
                        <v-select
                            class="mt-4"
                            outline
                            :items="[
                              { text: 'Mensal', value: 1 },
                              { text: 'Anual', value: 12 }
                            ]"
                            label="Tipo de plano"
                            item-value="value"
                            v-model="intervalo"
                            hide-details
                            hide-spin-buttons
                            :disabled="!!planoSelecionado || plano_externo"
                        ></v-select>
                        <br/>
                        <v-flex xs12>
                          <v-checkbox
                              v-model="tem_restricao_veiculo"
                              color="primary"
                              class="mt-0"
                              :disabled="plano_externo"
                          >
                            <template slot="label">
                                <span class="body-2 grey--text">Restringir uso a um único veículo</span>
                            </template>
                          </v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox
                              :disabled="plano_externo"
                              v-model="tem_limite_assinantes"
                              color="primary"
                              class="mt-0"
                              :hide-details="tem_limite_assinantes"
                              >
                              <template slot="label">
                                  <span class="body-2 grey--text">Limitar número de assinantes</span>
                              </template>
                            </v-checkbox>
                            <v-slide-x-transition>
                              <v-text-field
                                  v-show="tem_limite_assinantes"
                                  v-model="limite_assinantes"
                                  :rules="[
                                    v => !!v || 'Valor Inválido'
                                  ]"
                                  type="number"
                                  outline
                                  hide-details
                                  class="pt-2"
                                  label="Limite assinantes"
                                  ></v-text-field>
                            </v-slide-x-transition>
                          </v-flex>
                        <v-flex xs12>
                          <v-select
                            :disabled="plano_externo"
                            v-if="gateways_assinatura.length > 0"
                            v-model="gateway_selecionado"
                            :items="gateways_assinatura"
                            label="Gateway responsável"
                            outline
                            hide-details
                            clearable
                          ></v-select>
                        </v-flex>
                        <v-layout justify-space-around>
                          <v-btn
                              v-if="(posto && posto.valor_assinatura) || (rede && rede.valor_assinatura)"
                              class="mt-3"
                              round
                              @click="step = planos.length > 0 ? 2 : 1; planoSelecionado = undefined"
                              :loading="loading"
                            >
                              Voltar
                          </v-btn>
                          <v-btn
                              class="mt-3"
                              round
                              color="success"
                              :disabled="disabledBtn()"
                              @click="assinatura()"
                              :loading="loading"
                            >
                              Confirmar
                          </v-btn>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="4" class="pa-0">
                      <h2 class="text-xs-center">
                        Visualizar dados do plano
                      </h2>
                      <v-layout wrap justify-space-between v-if="planoSelecionado" style="font-size: 1.2em">
                        <v-flex xs11 class="mb-2 mt-2">
                          Descrição: <b>{{planoSelecionado.descricao}}</b>
                        </v-flex>
                        <v-flex xs5 class="mb-2" v-if="!planoSelecionado.externo">
                          Valor: <b>{{planoSelecionado.valor | currency({fractionCount: 2})}}</b>
                        </v-flex>
                        <v-flex xs5 class="mb-2" v-if="!planoSelecionado.externo ">
                          Tipo de plano: <b>{{ planoSelecionado.intervalo == 1 ? 'Mensal' : 'Anual' }}</b>
                        </v-flex>
                        <v-flex xs5 class="mb-2" v-if="!planoSelecionado.externo">
                          Renovação: <b>{{ planoSelecionado.gateway ? 'Automática' : 'Manual' }}</b>
                        </v-flex>
                        <v-flex xs5 class="mb-2" v-if="planoSelecionado.gateway">
                          Gateway: <b>{{ planoSelecionado.gateway === 1 ? 'EFI' : 'ASAAS' }}</b>
                        </v-flex>
                        <v-flex xs5 class="mb-2">
                          Usa um sistema externo: <b>{{ planoSelecionado.externo ? 'Sim' : 'Não' }}</b>
                        </v-flex>
                        <v-flex xs5 class="mb-2">
                          App: <b>{{ getAppName(planoSelecionado.app) }}</b>
                        </v-flex>
                        <v-flex xs5 class="mb-2" v-if="!planoSelecionado.externo">
                          Número de Assinantes: <b>{{ planoSelecionado.total_assinantes }}</b>
                        </v-flex>
                        <v-flex xs11 v-if="!planoSelecionado.externo">
                          Data de encerramento do ultimo assinante: <b>{{
                            planoSelecionado.data_vencimento_ultimo_assinante ?
                            planoSelecionado.data_vencimento_ultimo_assinante :
                            'Ainda não há assinantes'
                          }}</b>
                        </v-flex>
                      </v-layout>
                      <v-layout column class="mt-3">
                        <v-btn small round color="error" @click="step = 5">
                          Cancelar Plano
                        </v-btn>
                        <v-btn small round @click="step = 2, planoSelecionado = undefined">
                          Voltar
                        </v-btn>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="5" class="pa-0">
                      <h2 class="mb-3 text-xs-center error--text">
                        Tem certeza que deseja cancelar o programa de assinatura?
                      </h2>
                        <h4 class="mb-3 mr-2 ml-2 grey--text">
                          {{
                            planoSelecionado && planoSelecionado.data_vencimento_ultimo_assinante ?
                            `Esse plano contém assinates, você poderá excluir o plano, mas o benefícios ficarão disponiveis até a data de termino da assinatura do último assinante ${planoSelecionado.data_vencimento_ultimo_assinante}` :
                            'Esse plano não possui assinantes, você pode excluir esse plano e todos os beneficios criados.'
                          }}
                        </h4>
                      <v-layout justify-space-around>
                        <v-btn round @click="step = 2">Não</v-btn>
                        <v-btn round color="error" dark @click="cancelarAssinatura">Sim</v-btn>
                      </v-layout>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card-text>
    </v-card>
</template>

<script>
import { VMoney } from 'v-money'
export default {
  directives: { money: VMoney },
  data: () => ({
    step: 1,
    valor: '5,00',
    app_selecionado: undefined,
    gateway_selecionado: undefined,
    intervalo: 1,
    limite_assinantes: 0,
    tem_limite_assinantes: false,
    tem_restricao_veiculo: false,
    planos: [],
    planoSelecionado: undefined,
    plano_externo: false,
    appSelecionado: undefined,
    pagamento_model: {
      formulario: {},
      aceitar_credito: true,
      aceitar_debito: true
    },
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: false
    }
  }),
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    posto () {
      return this.$store.getters.posto
    },
    redes () {
      return this.$store.getters.redes
    },
    rede () {
      if (this.posto && this.posto.rede && this.redes) {
        return this.redes.find(r => r.id_rede === this.posto.rede)
      }
      return undefined
    },
    loading () {
      return this.$store.getters.loading
    },
    appList () {
      const posto = this.posto
      if (posto && posto.apps) {
        return posto.apps.map(app => {
          if (app === 'apetrus') return { text: 'Apetrus', value: 'apetrus' }
          else if (app === 'sindicato') return { text: 'Sindicato', value: 'sindicato' }
          else if (app === 'white_label') return { text: 'App do Posto', value: 'white_label' }
        })
      }
      return []
    },
    gateways_assinatura () {
      const pagamentoExtra = this.$store.getters.pagamentosExtra
      const GATEWAYS_COM_ASSINATURA = []

      for (let i in pagamentoExtra) {
        console.log(pagamentoExtra[i].forma_pagamento ? pagamentoExtra[i].forma_pagamento.descricao : '')
        if (pagamentoExtra[i].forma_pagamento &&
          (pagamentoExtra[i].forma_pagamento.descricao === 'efi' ||
            pagamentoExtra[i].forma_pagamento.descricao === 'asaas'
          )
        ) {
          GATEWAYS_COM_ASSINATURA.push(pagamentoExtra[i].forma_pagamento.descricao.toUpperCase())
        }
      }
      return GATEWAYS_COM_ASSINATURA
    }
  },
  async beforeMount () {
    this.$store.dispatch('carregarPagamentosExtra')
    this.$store.dispatch('carregarTiposMaquineta')
    this.pegarAdquirentesDisponiveis()
    if (!this.posto) {
      this.$emit('showSnackbar', 'error', 'Não foi encontrado um posto em sua conta')
      this.$emit('fechar')
    }
    await this.pegarPlanos()
    this.step = this.planos.length > 0 ? 2 : 1
  },
  methods: {
    pegarPlanos () {
      const data = { ativo: true }
      data.cnpj = this.posto.cnpj
      this.$store.dispatch('pegarPlanos', data).then(json => {
        this.planos = json
        this.step = this.planos.length > 0 ? 2 : 1
      })
    },
    pegarAdquirentesDisponiveis () {
      this.$store.dispatch('carregarTiposMaquineta')
    },
    cancelarAssinatura () {
      this.$store.dispatch('deletarAssinatura', {
        id_plano: this.planoSelecionado.id,
        posto: this.posto.cnpj
      }).then(() => {
        this.$emit('showSnackbar', 'success', 'Plano deletado com sucesso')
        this.pegarPlanos()
        this.planoSelecionado = undefined
      })
    },
    editar (plano) {
      this.planoSelecionado = plano
      this.valor = plano.valor
      this.intervalo = plano.intervalo
      this.limite_assinantes = plano.qtd_assinantes
      this.tem_limite_assinantes = plano.qtd_assinantes != null
      this.tem_restricao_veiculo = plano.vinculado_veiculo
      this.app_selecionado = plano.app
      this.step = 3
    },
    disabledBtn () {
      if (this.planoSelecionado && this.valor && this.planoSelecionado.valor === this.valor.replaceAll('.', '').replace(',', '.') && parseInt(this.planoSelecionado.qtd_assinantes) === parseInt(this.limite_assinantes) && (this.planoSelecionado.qtd_assinantes != null) === this.tem_limite_assinantes) return true
      return false
    },
    assinatura () {
      const data = {}

      if (this.valor === '0,00') {
        this.$emit('showSnackbar', 'error', 'Valor Inválido.')
        return
      }

      data.posto = this.posto.cnpj
      data.app = this.app_selecionado

      if (this.limite_assinantes) data.qtd_assinantes = this.limite_assinantes
      if (!this.tem_limite_assinantes) data.qtd_assinantes = undefined

      if (this.valor) {
        data.valor_assinatura = this.valor.replaceAll('.', '').replace(',', '.')
        data.intervalo = this.intervalo
      }

      if (this.planoSelecionado) data.id_plano = this.planoSelecionado.id

      if (this.tem_restricao_veiculo) data.vinculado_veiculo = this.tem_restricao_veiculo
      if (this.plano_externo) data.externo = true
      if (this.gateway_selecionado === 'EFI') data.gateway = 1
      else if (this.gateway_selecionado === 'ASAAS') data.gateway = 2
      this.$store.dispatch('assinatura', data).then(mensagem => {
        this.$emit('showSnackbar', 'success', mensagem)
        this.pegarPlanos()
      }).catch(error => {
        this.$emit('showSnackbar', 'error', error)
        this.pegarPlanos()
      })
    },
    novoPlano () {
      if (this.appList.length > 0) {
        this.app_selecionado = this.appList[0].value
      }
      this.step = 3
    },
    getAppName (appValue) {
      const app = this.appList.find(a => a.value === appValue)
      return app ? app.text : appValue
    }
  }
}
</script>
